// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIndividualDeductibleUpdateRequestDto
 */
export interface IIndividualDeductibleUpdateRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IIndividualDeductibleUpdateRequestDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IIndividualDeductibleUpdateRequestDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IIndividualDeductibleUpdateRequestDto
     */
    deductibles_amount: number;
}

/**
 * Check if a given object implements the IIndividualDeductibleUpdateRequestDto interface.
 */
export function instanceOfIIndividualDeductibleUpdateRequestDto(value: object): value is IIndividualDeductibleUpdateRequestDto {
    if (!('deductibles_amount' in value) || value['deductibles_amount'] === undefined) return false;
    return true;
}

export function IIndividualDeductibleUpdateRequestDtoFromJSON(json: any): IIndividualDeductibleUpdateRequestDto {
    return IIndividualDeductibleUpdateRequestDtoFromJSONTyped(json, false);
}

export function IIndividualDeductibleUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIndividualDeductibleUpdateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'deductibles_amount': json['deductibles_amount'],
    };
}

export function IIndividualDeductibleUpdateRequestDtoToJSON(json: any): IIndividualDeductibleUpdateRequestDto {
    return IIndividualDeductibleUpdateRequestDtoToJSONTyped(json, false);
}

export function IIndividualDeductibleUpdateRequestDtoToJSONTyped(value?: IIndividualDeductibleUpdateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'deductibles_amount': value['deductibles_amount'],
    };
}

